import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UserModel} from "../../../models/user.model";
import { Router} from "@angular/router";
import {UserService} from "../../../services/user.service";
import {Subscription} from "rxjs";
import {GoogleAnalyticsService} from "ngx-google-analytics";
import {TrackingHelperService} from "../../../services/tracking-helper.service";
import {ConfigService} from "../../../services/config.service";

declare var bootstrap: any;


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  brandName;
  assetsSource;
  logoFileName;
  logoAltText;
  isRival;

  user!: UserModel | null;  //needed because of the currency
  userSubs: Subscription;
  balance!: number | null;
  balanceSubs: Subscription;


  hasMinReg: boolean;

  isSignInModalOpen = false;
  isSignUpModalOpen = false;


  @Output() sidebarToggleEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() sidebarToggled: boolean = false;


  constructor(
    private configs: ConfigService,
    private userService: UserService,
    private router: Router,
    private gaService: GoogleAnalyticsService,
    private trackingService: TrackingHelperService
  ) {
    this.isRival = this.configs.isRivalCasino;
    this.brandName = this.configs.brandName;
    this.hasMinReg = this.configs.hasMinimalRegistration;
    // console.log(this.hasMinReg) //todo delete this or whatever we need for min reg
    this.assetsSource = this.configs.assetsPath;
    this.logoFileName = this.configs.logoName;
    this.logoAltText = this.configs.logoAltText;

    this.userSubs = this.userService.userObject.subscribe( userData => {
      this.user = userData;
    })

    this.balanceSubs = this.userService.balanceObject.subscribe( balance => {
      this.balance = balance;
    })

  }

  // // removed from here to afterviewInit to have the modal when we want to toggle it
  // ngOnInit(){
  // //   // for landings - toggle registration in instantplay routes when they click on old landings -
  //   const currentUrl = this.router.url;
  //   if(currentUrl.includes('instantplay') || currentUrl.includes('register') || currentUrl.includes('x=registration')){
  //     this.toggleSignUpModal();
  //   }
  // }

  ngAfterViewInit(): void {
    // for landings - toggle registration in instantplay routes when they click on old landings
    const currentUrl = this.router.url;
    if(currentUrl.includes('instantplay') || currentUrl.includes('register') || currentUrl.includes('x=registration')){
      // this.toggleSignUpModal();
      //to prevent "Expression has changed after it was checked" error in dev mode: https://blog.angular-university.io/angular-debugging/
      setTimeout(() => this.toggleSignUpModal());
    }
  }


  goToCashier(){
    this.router.navigate(['account', 'cashier'])
  }


  toggleSidebar(){
    this.sidebarToggled = !this.sidebarToggled;
    this.sidebarToggleEvent.emit(this.sidebarToggled);
  }



  toggleSignInModal(): void {
    if (this.isSignInModalOpen) return;

    //to prevent error: bootstrap is not loaded yet when modal is clicked
    try {
      if (typeof bootstrap === 'undefined' || !bootstrap.Modal) {
        throw new Error('Bootstrap library is not loaded.');
      }
      // Deactivate Bootstrap modals preventing text input fields focus
      bootstrap.Modal.prototype._initializeFocusTrap = function () {
        return {
          activate: function () { },
          deactivate: function () { }
        };
      };

      const modalElement = document.getElementById('signInModal');
      if (!modalElement) {
        throw new Error('Modal element with ID "signInModal" not found.');
      }

      const signInModal = new bootstrap.Modal(modalElement, {});
      this.isSignInModalOpen = true;
      signInModal.show();

      modalElement.addEventListener('hidden.bs.modal', () => {
        this.isSignInModalOpen = false;
        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      }, { once: true });

    } catch (error) {
      console.error('Error in toggleSignInModal:', error);
      this.router.navigate(['/legacy'])
    }

  }


  toggleSignUpModal(): void {
    if (this.isSignUpModalOpen) return;

    //to prevent error: bootstrap is not loaded yet when modal is clicked
    try {
      if (typeof bootstrap === 'undefined' || !bootstrap.Modal) {
        throw new Error('Bootstrap library is not loaded.');
      }

      // Deactivate Bootstrap modals preventing text input fields focus
      bootstrap.Modal.prototype._initializeFocusTrap = function () {
        return {
          activate: function () { },
          deactivate: function () { }
        };
      };

      let modalElement: HTMLElement | null;
      if (this.hasMinReg){
        modalElement = document.getElementById('minSignUpModal');
      } else {
        modalElement = document.getElementById('signUpModal');
      }
      if (!modalElement) {
        throw new Error('Modal element for sign up not found.');
      }
      const signUpModal = new bootstrap.Modal(modalElement, {});
      this.isSignUpModalOpen = true;
      signUpModal.show();

      modalElement.addEventListener('hidden.bs.modal', () => {
        this.isSignUpModalOpen = false;
        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      }, { once: true });

      //send event to GA
      this.gaService.event('register_page_loaded', undefined, undefined, undefined, undefined,{play_mode: "real", ...this.trackingService.getAffiliateOptions() });


    } catch (error) {
      console.error('Error in toggleSignUpModal:', error);
      this.router.navigate(['/legacy'])
    }

  }

  ngOnDestroy(){
    this.userSubs?.unsubscribe();
    this.balanceSubs?.unsubscribe();
  }


}

